import type { CustomerAlias, CustomerIndexItemDto } from '@techgitter/contracts';

export interface VendorMappingRecord {
  customer: CustomerIndexItemDto;
  alias: CustomerAlias;
}

export interface VendorMappingsResult {
  items: VendorMappingRecord[];
  warnings: string[];
}

export async function getVendorMappings(
  vendorId: string,
  signal?: AbortSignal
): Promise<VendorMappingsResult> {
  const response = await fetch(`/api/vendors/${vendorId}/mappings`, {
    method: 'GET',
    headers: { 'Accept': 'application/json' },
    signal,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch vendor mappings: ${response.status} ${response.statusText}`);
  }

  const data: { items: VendorMappingRecord[] } = await response.json();
  
  // Sort by customer displayName then alias
  data.items.sort((a, b) => {
    const customerCmp = a.customer.displayName.localeCompare(b.customer.displayName);
    if (customerCmp !== 0) return customerCmp;
    return a.alias.alias.localeCompare(b.alias.alias);
  });

  return { items: data.items, warnings: [] };
}
